export enum EnumUrlsPages {
  about = '/companya/',
  gallery = '/fotogalereya/', // TODO SEO: 404, страницы нет
  delivery = '/uslugi/',
  policy = '/clients/dokumenty/politika-konfidenczialnosti/',
  tracking = '/tracking/',
  calculator = '/calculator/',
  contacts = '/contacts/',
  story = '/story/', // TODO SEO: 404, страницы нет
  questions = '/clients/voprosy-o-dostavke/',
  docs = '/clients/dokumenty/',
  live = '/blog/',
  vacancies = '/vacancy/',
  reviews = '/otzyvy/',
  partners = '/partners/',
  clients = '/companya/nashi-klienty/', // TODO SEO: 404, страницы нет
  cashService = '/uslugi/kassovoe-obsluzhivanie/',
  returnDocuments = '/uslugi/vozvrat-soprovoditelnykh-dokumentov/',
  integration = '/clients/lichnyy-kabinet/',

  deliveryMsk = '/geografiya/dostavka-po-moskve-i-oblasti/',
  deliveryMskToSpb = '/geografiya/dostavka-iz-moskvy-v-sankt-peterburg/',
  deliverySameDay = '/uslugi/dostavka-den-v-den/',
  deliveryShipFromStore = '/uslugi/dostavka-dlya-oflayn-magazinov/',
  deliveryRu = '/agregator-dostavki-dlya-internet-magazinov/', // TODO SEO: цепочка 301 → /filialy-kompanii-dalli/ → /uslugi/punkty-vydachi-zakazov/
  deliveryPVZ = '/uslugi/punkty-vydachi-zakazov/',
  deliveryInternet = '/uslugi/dostavka-dlya-internet-magazinov/',
  deliveryB2B = '/uslugi/dostavka-b2b/',
  deliveryMarketplace = '/uslugi/dostavka-tovarov-na-marketpleysy/',
  deliveryForLegal = '/dostavka-dlya-yuridicheskikh-lits-i-organizatsiy/', // TODO SEO: 301 на главную, страницы нет
  deliveryFiliali = '/filialy-kompanii-dalli/', // TODO SEO: 301 → /uslugi/punkty-vydachi-zakazov/ (смысл ссылки другой)

  deliveryOutsourcing = '/uslugi/autsorsing-internet-magazinov/',
  deliveryComprehensiveService = '/uslugi/obsluzhivanie-internet-magazinov/',
  deliveryLogistics = '/uslugi/logistika-dlya-internet-magazina/',
  deliverySpb = '/geografiya/dostavka-po-sankt-peterburgu-i-oblasti/',
  deliveryNextDay = '/uslugi/dostavka-na-sleduyuschiy-den/',

  deliverySZFO = '/geografiya/dostavka-severo-zapadnyy-federalnyy-okrug/',
  deliveryCFO = '/geografiya/dostavka-centralnyy-federalnyy-okrug/',
  deliveryUFO = '/geografiya/dostavka-yuzhnyy-federalnyy-okrug/',
  deliveryPFO = '/geografiya/dostavka-privolzhskij-federalnyj-okrug/',
  deliveryUrFO = '/geografiya/dostavka-uralskiy-federalnyy-okrug/',
  deliverySbFO = '/geografiya/dostavka-sibirskiy-federalnyy-okrug/',
  deliverySK = '/geografiya/dostavka-v-severo-kavkazskiy-federalniy-okrug/'  ,

  notFound = '/not-found',
}
